export const showToast = ({
    type = "info",
    title = "",
    message = "",
    duration = 4500,
  }) => {
    window.dispatchEvent(
      new CustomEvent("zootel-toast", {
        detail: {
          id: `${Date.now()}-${Math.random()}`,
          type,
          title,
          message,
          duration,
        },
      }),
    );
  };
  
  export const showSuccess = (message, title = "Success") => {
    showToast({
      type: "success",
      title,
      message,
    });
  };
  
  export const showError = (message, title = "Error") => {
    showToast({
      type: "error",
      title,
      message,
    });
  };
  
  export const showWarning = (message, title = "Warning") => {
    showToast({
      type: "warning",
      title,
      message,
    });
  };
  
  export const showInfo = (message, title = "Info") => {
    showToast({
      type: "info",
      title,
      message,
    });
  };